import React, { useState, useEffect, useRef } from "react";
import { Modal, Form, Col, Spinner, InputGroup } from "react-bootstrap";
import moment from "moment";
import { Tooltip } from "@material-ui/core";

import MealService from "services/meal.service";
import AuthService from "services/auth.service";

import BreakfastIcon from "assets/icons/meal-breakfast-icon.svg";
import LunchIcon from "assets/icons/meal-lunch-icon.svg";
import SnackIcon from "assets/icons/meal-snack-icon.svg";
import DinnerIcon from "assets/icons/meal-dinner-icon.svg";
import CloseBtn from "assets/icons/Close.svg";
import RemoveIcon from "assets/icons/Remove.svg";
import CheckIcon from "assets/icons/white-check.svg";
import NutritionistAvatar from "assets/icons/avatar-nutritionist.svg";
import MaleUserAvatar from "assets/icons/avatar-male-user.svg";
import FemaleUserAvatar from "assets/icons/avatar-female-user.svg";
import AskAbeAvatar from "assets/icons/avatar-ask-abe.svg";
import DoctorVerifiedBadge from "assets/icons/doctor-verified-badge.svg";
import AiPoweredIcon from "assets/icons/ai-powered-icon.svg";
import InfoIcon from "assets/icons/info-icon-black.svg";

function FoodLogModal({ props, gender, user_id, type, getMeals }) {
  const isClosed = useRef(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [meal, setMeal] = useState(props);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingPost, setLoadingPost] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);

  // Form
  const [selectedMealType] = useState(props?.meal_type);
  const [TrafficLightStatus, setTrafficLightStatus] = useState(
    props?.traffic_light_status,
  );
  const [IsVegetableStatus, setIsVegetableStatus] = useState(
    props?.is_vegetable,
  );
  const [SkipStatus, setSkipStatus] = useState(props?.is_skipped);
  const [IsVerifiedStatus, setVerifiedStatus] = useState(props?.is_verified);
  const [Calories, setCalories] = useState(props?.calories);
  const [Proteins, setProteins] = useState(props?.proteins);
  const [Fats, setFats] = useState(props?.fats);
  const [Carbohydrates, setCarbohydrates] = useState(props?.carbohydrates);
  const [ServingSize, setServingSize] = useState(props?.serving_size);

  //Comments
  const [Comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  //Teleconsult
  const [isOpenChat, setIsOpenChat] = useState(true);

  const [isAskAbeDisabled, setAskAbeDisabled] = useState(
    props?.disable_ai_feedback,
  );

  useEffect(() => {
    if (show === true) {
      getComments();
      getOpenChat();

      if (meal.has_new_comment === true) {
        updateRead();
      }
    }
    return () => {
      isClosed.current = true;
    };
  }, [show]); // eslint-disable-line

  const updateRead = () => {
    MealService.updateRead(meal.id);
  };

  const profilePicture = (e) => {
    const getAvatar = () => {
      if (e.role === "Doctor") {
        return e.is_ai_powered ? AskAbeAvatar : NutritionistAvatar;
      }
      return gender === "female" ? FemaleUserAvatar : MaleUserAvatar;
    };

    return (
      <img
        src={getAvatar()}
        className="comment-row__image"
        alt="user-profile"
      />
    );
  };

  const MealType = (meal_type) => {
    switch (meal_type) {
      case "breakfast":
        return <img src={BreakfastIcon} alt="breakfast-icon" />;
      case "lunch":
        return <img src={LunchIcon} alt="lunch-icon" />;
      case "dinner":
        return <img src={DinnerIcon} alt="dinner-icon" />;
      default:
        return <img src={SnackIcon} alt="snack-icon" />;
    }
  };

  const handleClose = () => {
    setShow(false);
    setNewComment("");
    setMeal(props);
    setLoading(false);
    if (getMeals) {
      const url = new URL(window.location.href);
      url.searchParams.delete("meal_id");
      window.history.replaceState({}, "", url);
      getMeals();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoadingSave(true);

    const params = {
      traffic_light_status: TrafficLightStatus,
      calories: Calories,
      proteins: Proteins,
      fats: Fats,
      carbohydrates: Carbohydrates,
      serving_size: ServingSize,
      is_skipped: SkipStatus,
      is_vegetable: IsVegetableStatus,
      is_verified: IsVerifiedStatus,
    };
    MealService.updateMeal(meal.id, params).then(
      (res) => {
        setMeal(res);
        setLoadingSave(false);
        alert("Meal has been save successfully");
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
        setLoadingSave(false);
        alert("Error, please try again later");
      },
    );
  };

  const handleSend = (e) => {
    e.preventDefault();
    setLoadingPost(true);

    const params = {
      context: newComment,
    };
    MealService.createComment(meal.id, params).then(
      (res) => {
        setNewComment("");
        setComments(res.meal_comments);
        setAskAbeDisabled(true);
        setLoadingPost(false);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
        setLoadingPost(false);
        alert("Error, please try again later");
      },
    );
  };

  const getOpenChat = () => {
    const params = {
      user_id: user_id,
    };

    MealService.getOpenChat(params).then(
      (res) => {
        setIsOpenChat(res);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      },
    );
  };

  const createChat = (e) => {
    e.preventDefault();
    setLoadingChat(true);

    const params = {
      user_id: user_id,
    };

    MealService.createChat(params).then(
      (res) => {
        setLoadingChat(false);
        window.location.replace("/eb/teleconsult");
      },
      (error) => {
        setLoadingChat(false);
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      },
    );
  };

  const confirmDelete = (e, comment_id) => {
    e.preventDefault();

    const confirmed = window.confirm(
      "You are about to delete this comment. Confirm?",
    );

    if (confirmed) {
      setLoading(true);

      MealService.deleteComment(meal.id, comment_id).then(
        (res) => {
          setComments(res.meal_comments);
          setLoading(false);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
          setLoading(false);
        },
      );
    }
  };

  const getComments = () => {
    setLoading(true);
    MealService.getComments(meal.id).then(
      (res) => {
        setComments(res.meal_comments);
        setLoading(false);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
        setLoading(false);
      },
    );
  };

  return (
    <div>
      <button
        className={
          "btn btn-link p-0" +
          (type === "list" ? " font-size-10" : " font-size-5")
        }
        style={{ color: "black" }}
        onClick={handleShow}
      >
        {meal.name}
      </button>
      <Modal
        className="food-log-modal"
        size="xl"
        show={show}
        onHide={handleClose}
      >
        <Modal.Header>
          <button type="button" className="close" onClick={handleClose}>
            <img src={CloseBtn} alt="modal-close" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="mb-3 col-md-5">
              <div className="content-container">
                <a href={meal.image} target="_blank" rel="noreferrer">
                  {meal.is_ai_rated === true && (
                    <span class="ai-rated-badge">AI-Rated Meal</span>
                  )}
                  <img
                    src={meal.image_thumb}
                    alt="food-img"
                    className="meal-img"
                  />
                </a>

                <Form className="form">
                  <div className="form-container">
                    <div className="form-content">
                      <div className="meal-type-label">Meal Type</div>
                      <Form.Group
                        controlId="formMealType"
                        className="meal-type-container"
                      >
                        <div className="meal-type">
                          {MealType(selectedMealType)}
                        </div>
                      </Form.Group>
                      <Form.Group controlId="formDate">
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          placeholder="Enter date"
                          value={meal.date}
                          readOnly
                        />
                      </Form.Group>
                      <Form.Group controlId="formName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter name"
                          value={meal.name}
                          readOnly
                        />
                      </Form.Group>
                      {/* <Form.Row>
                        <Col>
                          <Form.Group controlId="formServingSize">
                            <Form.Label>Serving Size <span style={{ fontSize: "0.7em" }}>(est.)</span></Form.Label>
                            <InputGroup>
                              <Form.Control
                                type={
                                  meal.serving_type !== null ? "number" : "text"
                                }
                                value={ServingSize || ""}
                                min={0}
                                onChange={(e) => setServingSize(e.target.value)}
                              />
                              <InputGroup.Text
                                className={
                                  meal.serving_type !== null
                                    ? ""
                                    : "hide-postfix"
                                }
                                id="basic-addon2"
                              >
                                {meal.serving_type}
                              </InputGroup.Text>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      </Form.Row> */}
                      <Form.Row>
                        <Col>
                          <Form.Group controlId="formCalories">
                            <Form.Label>
                              Calories{" "}
                              <span style={{ fontSize: "0.7em" }}>(est.)</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Enter calories"
                              value={Calories || ""}
                              min={0}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) {
                                  setCalories(value);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group controlId="formCarbohydrates">
                            <Form.Label>
                              Carbohydrates{" "}
                              <span style={{ fontSize: "0.7em" }}>(g)</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              value={Carbohydrates}
                              min={0}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) {
                                  setCarbohydrates(value);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Form.Row>
                      <Form.Row>
                        <Col>
                          <Form.Group controlId="formProteins">
                            <Form.Label>
                              Proteins{" "}
                              <span style={{ fontSize: "0.7em" }}>(g)</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              value={Proteins}
                              min={0}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) {
                                  setProteins(value);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group controlId="formFats">
                            <Form.Label>
                              Fats{" "}
                              <span style={{ fontSize: "0.7em" }}>(g)</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              value={Fats}
                              min={0}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) {
                                  setFats(value);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Form.Row>
                      <Form.Group controlId="formNotes">
                        <Form.Label>
                          Notes{" "}
                          <span style={{ fontSize: "0.7em" }}>(Optional)</span>
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows="2"
                          value={meal.notes || ""}
                          style={{ resize: "none" }}
                          readOnly
                        />
                      </Form.Group>
                      <Form.Group
                        controlId="formTrafficLightStatus"
                        className="meal-traffic-light-container"
                      >
                        <Form.Check inline>
                          <Form.Check
                            name="traffic-light-status"
                            value="red"
                            type="radio"
                            aria-label="radio"
                            checked={TrafficLightStatus === "red"}
                            onChange={(e) =>
                              setTrafficLightStatus(e.target.value)
                            }
                            label="Red"
                            style={{ color: "red" }}
                          />
                        </Form.Check>

                        <Form.Check inline>
                          <Form.Check
                            name="traffic-light-status"
                            value="yellow"
                            type="radio"
                            aria-label="radio"
                            checked={TrafficLightStatus === "yellow"}
                            onChange={(e) =>
                              setTrafficLightStatus(e.target.value)
                            }
                            label="Yellow"
                            style={{ color: "#F39200" }}
                          />
                        </Form.Check>

                        <Form.Check inline>
                          <Form.Check
                            name="traffic-light-status"
                            value="green"
                            type="radio"
                            aria-label="radio"
                            checked={TrafficLightStatus === "green"}
                            onChange={(e) =>
                              setTrafficLightStatus(e.target.value)
                            }
                            label="Green"
                            style={{ color: "green" }}
                          />
                        </Form.Check>
                      </Form.Group>

                      <Form.Group
                        controlId="formIsVegetableStatus"
                        className="meal-checkbox-container"
                      >
                        <Form.Check
                          name="is_vegetable"
                          type="checkbox"
                          aria-label="checkbox"
                          checked={IsVegetableStatus}
                          onChange={(e) =>
                            setIsVegetableStatus(e.target.checked)
                          }
                          label="Plant-Based Diet"
                        />
                      </Form.Group>

                      <Form.Group
                        controlId="formSkipStatus"
                        className="meal-checkbox-container"
                      >
                        <Form.Check
                          name="skip"
                          type="checkbox"
                          aria-label="checkbox"
                          checked={SkipStatus}
                          onChange={(e) => setSkipStatus(e.target.checked)}
                          label="Skip"
                        />
                      </Form.Group>

                      <Form.Group
                        controlId="formIsVerifiedStatus"
                        className="meal-checkbox-container"
                      >
                        <Form.Check
                          name="is_verified"
                          type="checkbox"
                          aria-label="checkbox"
                          checked={IsVerifiedStatus}
                          onChange={(e) => setVerifiedStatus(e.target.checked)}
                          label="Mark As Verified"
                        />
                      </Form.Group>
                    </div>
                    <div className="form-save">
                      <button
                        className="btn btn-link save-button"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        {loadingSave ? (
                          <div className="loader">
                            <Spinner animation="border" className="spinner" />
                          </div>
                        ) : (
                          <>
                            <img src={CheckIcon} alt="save-icon" />
                            <span>Save</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            <div className="mb-3 col-md-7">
              <div className="comments-container">
                <div className="title-bar">
                  <div className="title">Comments</div>
                  {isAskAbeDisabled && (
                    <>
                      <div className="badge askabe-disabled">
                        AskAbe Disabled
                      </div>
                      <Tooltip
                        placement="right"
                        arrow
                        title={
                          <div
                            style={{
                              padding: "8px",
                              maxWidth: "240px",
                              fontSize: "12px",
                              margin: "0",
                            }}
                          >
                            <h5 style={{ lineHeight: "18px" }}>
                              AI Comment Disabled
                            </h5>
                            <p style={{ margin: 0, lineHeight: "20px" }}>
                              Since you’ve commented manually, future feedback
                              will be your responsibility.
                            </p>
                          </div>
                        }
                      >
                        <img src={InfoIcon} />
                      </Tooltip>
                    </>
                  )}
                  <button
                    className={
                      "btn btn-link ml-auto" +
                      (isOpenChat === true ? " disabled" : "")
                    }
                    type="submit"
                    onClick={createChat}
                  >
                    {loadingChat ? (
                      <div className="loader">
                        <Spinner animation="border" className="spinner" />
                      </div>
                    ) : (
                      <>Start Chat</>
                    )}
                  </button>
                </div>{" "}
                {loading ? (
                  <div className="loader">
                    <Spinner animation="border" className="spinner" />
                  </div>
                ) : (
                  <>
                    <div className="scroll">
                      {Comments.map((q, i) => (
                        <div className="comment-row" key={`comments-${i}`}>
                          {profilePicture(q)}
                          <div className="comment-row__text">
                            <div className="user-info">
                              <div className="name">{q.name}</div>
                              {q.is_ai_powered === true && (
                                <img
                                  src={DoctorVerifiedBadge}
                                  className="verified-badge"
                                  alt="doctor-verified-badge"
                                />
                              )}
                              <span className="time">
                                {moment(q.created_at).fromNow()}
                              </span>
                            </div>
                            <p className="content">{q.body}</p>
                            {q.is_ai_powered === true && (
                              <span class="ai-powered-badge">
                                <img src={AiPoweredIcon} />
                                AI Powered
                              </span>
                            )}
                          </div>
                          <div className="comment-row__action">
                            {q.role === "Doctor" && (
                              <button
                                className="btn btn-link"
                                onClick={(e) => confirmDelete(e, q.id)}
                              >
                                <img src={RemoveIcon} alt="delete-icon" />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="comment-footer">
                      <textarea
                        id="comment-input"
                        className="comment-input"
                        type="area"
                        rows={1}
                        maxLength={500}
                        placeholder="Type a comment here"
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                      />

                      <button
                        className={
                          "btn btn-link post-button ml-auto" +
                          (newComment ? "" : " disabled")
                        }
                        type="submit"
                        onClick={handleSend}
                      >
                        {loadingPost ? (
                          <div className="loader">
                            <Spinner animation="border" className="spinner" />
                          </div>
                        ) : (
                          <>Post</>
                        )}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FoodLogModal;
